<template>
  <div ref="cell" class="grid-view__cell">
    <div class="grid-field-duration">
      <SearchHighlightedText
        :text="formatValue(field, value)"
        :search-term="searchTerm"
      />
    </div>
  </div>
</template>

<script>
import { formatDurationValue } from '@baserow/modules/database/utils/duration'
import SearchHighlightedText from '@baserow/modules/database/components/view/grid/fields/SearchHighlightedText'

export default {
  name: 'FunctionalGridViewFieldDuration',
  components: { SearchHighlightedText },
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: {
      type: null,
      default: null,
    },
    searchTerm: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    formatValue(field, value) {
      return formatDurationValue(value, field.duration_format)
    },
  },
}
</script>
